<template>
  <layout>
    <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
    <div slot="content">
      <div class="btn-type1" style="">
        <button class="btn-size btn-gray btn-space" @click="save()">
        <span class="btn-icon">
            <i class="fas fa-save"></i>
        </span>
          반품저장
        </button>
        <button class="btn-size btn-gray" @click="goSearch()">
        <span class="btn-icon">
            <i class="fas fa-search"></i>
        </span>
          검색
        </button>
      </div>
      <div class="pop-content-search">
            <el-form size="mini" style="margin-left: -35px;" @submit.prevent>
              <el-row :gutter="24">
                <el-col :span="8">
                  <el-form-item label="반품구분" label-width="100px">
                    <el-select v-model="form.outType" disabled>
                      <el-option value='' label="미사용자재" ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="반품일자" label-width="120px">
                        <el-date-picker type="date" placeholder="Pick a date" v-model="form.outDt" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
         </div>

         <div class="pop-content-search">
            <el-form size="mini" @submit.prevent>
              <el-row :gutter="24">
                <el-col :span="7">
                  <el-form-item label="제조사" label-width="60px">
                    <el-select v-model="form.maker" >
                      <el-option value='' label="전체">전체</el-option>
                      <el-option
                          v-for="item in combos['maker']"
                          :key="item.value"
                          :value="item.key"
                          :label="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-row>
                    <el-form-item label="제품군" label-width="130px">
                      <el-col :span="40">
                        <el-select v-model="form.itemGroup" @change="onItemGroupChange">
                          <el-option value='' label="전체">전체</el-option>
                          <el-option
                              v-for="item in combos['itemGroup']"
                              :key="item.key"
                              :value="item.key"
                              :label="item.value">
                          </el-option>
                        </el-select>
                      </el-col>

                    </el-form-item>
                  </el-row>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="품번" label-width="100px">
                    <el-input type="text" v-model="form.itemCd"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>

      <div class="grid-wrap">
        <div class="table-area">
          <div class="table-b">
            <ag-grid-vue
                style="width: 100%; height: 330px;"
                class="ag-theme-alpine"
                :framework-components="frameworkComponents"
                :column-defs="columnDefs"
                :grid-options="gridOptions"
                :row-data="rowData"
                :default-col-def="defaultColDef"
                :enableRangeSelection="true"
                @grid-ready="onGridReady"
                @cell-clicked="onCellClicked"
                @cell-value-changed="onCellValueChanged"

                :stopEditingWhenCellsLoseFocus="true"
            />
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>


<script>
/**
* * components
*/
import Layout from '@/components/Slot/ModalSlot.vue';

import {AgGridVue} from 'ag-grid-vue';
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";


function _url(...args) {
  args = args.map(x => String(x || '').trim().replace(/^\/*|\/*$/g, ''))
  args = args.filter(x => x)
  return args.join('/')
}


export default {
  props: {
    data: {
      Type: Object
      , required: false
    },
  },
  components: {Layout, AgGridVue},
  data() {
    return {
      title: '반품자재등록',
      form: {
        companyId : '',
        outDt : this.$moment().format('YYYY-MM-DD'),
        maker : '',              // 제조사
        catId : '',              // 지역
        subCatId: '',            // 지역 상세
        itemGroup : '',          // 제품군
        outType : '',             // 반품구분
        txtGoodQty : 0,
        description : '',
        useModelNm : '',
        itemCd : '',             // 품번
        asAgentId : '',          //back outAsAgentId에 꽂혀야됨
        subItemGroup: '',        // 제품군 상세
        sortType : '',           // 승인/정산처리유형
        page : 1,
        totalPage : 99999,
        curPage : 0,
        totalCount : 99999,
        processTime : '',
        inType: '',              //출고구분
      },
      combos: {
        'maker' : [],
        'catId' : [],            // 지역센터
        'subCatId' : [],         // 지역 상세
        'itemGroup' : [],        // 제품군
        'subItemGroup' : [],     // 제품군 상세
        'inType' : [],           // 출고구분
        'outType' : [],           // 반품구분
      },
      // AG-GRID OPTION [START]
      rowData:[],
      rowDataOrg:[], /** 조회후 데이타 백업 */
      gridOptions: {},
      frameworkComponents : {
        checkBox: CheckboxCellRenderer,
      },
      columnDefs:[
        {
          headerName:'No',
          field:'no',
          width:80,
          cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {headerName:'선택', field: 'chk', width: 80, cellRenderer: 'checkBox'},
        {headerName:'제조사', field:'makerNm', width:120, cellStyle : {textAlign: 'center'}},
        {headerName:'제품군', field:'itemGroupNm', width:120, cellStyle : {textAlign: 'center'}},
        {headerName:'품번', field:'itemCd', width:150, cellStyle : {textAlign: 'left'}},
        {headerName:'품명', field:'itemNm', width:180, cellStyle : {textAlign: 'left'}},
        {headerName:'재고수량', field:'totalGoodQty', width:110, cellStyle : {textAlign: 'right'},
          valueFormatter: (params) => {
            return this.chkNumber(params, '', '');
          }},
        {headerName:'반품수량', field:'txtGoodQty', width:110, cellStyle : {textAlign: 'right'}, editable: true,
          valueFormatter: (params) => {
            return this.getNumberFormat(params.value);
          }}
      ],
      defaultColDef: {
        resizable: true,
        filter:true,
        sortable: true
      },
      statusBar: null,
      changeCatIdShow : false,
      changeItemGroupShow : false,
      catIdDisabled : false,
      editableTxtGoodQty : true,
      editableTxtBadQty : true,
      // AG-GRID OPTION [END]
    }
  },
  mounted() {
    this.form.companyId = this.$store.state.loginInfo.compCd;
    this.form.asAgentId = this.$store.state.loginInfo.asAgentId;
    this.getCombo()
    this.getConfigValue()
  },
  destroyed() {
    //ModalSlot open z-index change
    //$('.lnb').css('z-index', '7');
  },
  methods: {
    changeTab(params) {
      this.viewer = params.tabId;
    },
    closeModal() {
      console.log(this.$parent)
      this.$parent.close();
    },
    handleNodeClick(data) {
      console.log(data);
    },
    onGridReady(){

    },
    rowDoubleClick(params){
      this.$emit('close', params.data);
    },
    onCellClicked(params) {
      //   this.$emit('close', params.data);
      //   this.closeModal();
      const idx = params.rowIndex;
      const field = params.colDef.field;
    },
    getCombo() {
      this.getMakerCombo();
      this.getItemGroupCombo();
      this.getInTypeCombo();
      this.getCatIdCombo();
      this.getOutTypCombo();// 반품구분
    },
    getConfigValue() {
      this.$http.get(`/api/config/keyPath/info`, {params: {keyPath: 'System.MainAsAgentId'}})
          .then(response => {
            this.form.inAsAgentId = response.data[0].configValue;
          });
    },
    getOutTypCombo(){
      this.$http.get(`/api/codeMng/combo`, { params: {parentId: 285} })
          .then(response => {
            this.combos['outType'] = response.data || []
          });
    },
    getMakerCombo(){
      this.$http.get(`/api/codeMng/combo`, { params: {parentId: 196} })
          .then(response => {
            this.combos['maker'] = response.data || []
          });
    },
    getItemGroupCombo(){
      this.$http.get(`/api/codeMng/combo`, { params: {parentId: 143} })
          .then(response => {
            this.combos['itemGroup'] = response.data || []
          });
    },
    getInTypeCombo(){
      this.$http.get(`/api/codeMng/combo`, { params: {parentId: 294} })
          .then(response => {
            this.combos['inType'] = response.data.filter(x=>x.key !== 'Order') || []
          });
    },
    getCatIdCombo(){
      this.$http.get(`/api/codeMng/combo/catId`, { params: {parentId: 217} })
          .then(response => {
            this.combos['catId'] = response.data || []
          });
    },
    onCatIdChange(param){
      this.form.subCatId = '';
      if(param === '') this.changeCatIdShow =  false;
      else{
        this.changeCatIdShow =  true;
        // 지역 상세
        this.$http.get(`/api/codeMng/combo/catId`, { params: {parentId: param} })
            .then(response => {
              this.combos['subCatId'] = response.data || []
            });
      }
    },
    onItemGroupChange(param){
      this.form.subItemGroup = '';
      if(param === '' ) this.changeItemGroupShow =  false;
      else{
        this.changeItemGroupShow =  true;
        this.$http.get(`/api/codeMng/detail`, { params: {parentId: 143} })  // 제품군
            .then(response => {
              let subData = response.data.filter(x => x.catKey === param);
              this.$http.get(`/api/codeMng/combo`, { params: {parentId: subData[0].catId} })
                  .then(response => {
                    this.combos['subItemGroup'] = response.data || []
                  });
            });
      }
    },
    onInTypeChange(param){
      if(param === 'Erp') {
        this.catIdDisabled = true
        this.form.catId = '';      // 지역센터
        this.form.subCatId = '';   // 지역 상세
      } else {
        this.catIdDisabled = false
      }
    },
    goSearch(){

      this.$store.commit('loading')

      this.$http.post(_url("/api/workMng/mateStock/list"), {
        companyId : this.form.companyId,
        maker : this.form.maker,               // 제조사
        itemGroup : this.form.itemGroup,         // 제품군
        useModelNm : this.form.useModelNm,     //
        itemCd : this.form.itemCd,             // 품번
        catId : 0,
        asAgentId : this.form.asAgentId,
        description : this.form.description,
        sortType : this.form.sortType,         // 승인/정산처리유형
        page : 1,
        totalPage : 99999,
        curPage : 0,
        totalCount : 99999,
        processTime : ''
      }).then(response => {
            this.rowData = response.data.map(x => {
              x.totalGoodQty = x.goodQty + x.recycleQty //재고수량(totalGoodQty)
              return x;
            })
          }).finally(() => {
            this.$store.commit('finish')
      });
    },
    save() {
      let vm = this;

      if(vm.form.outDt === '' || vm.form.outDt === null || vm.form.outDt === undefined)   {
        this.$swal({type: 'warning', text: '반품일자를 입력해주세요.'});
        return false;
      }


      let list = this.rowData.filter(v => v.chk);

      vm.result = [];

      if(list.length > 0){

        vm.result = list.map(x => {
          x = Object.assign(x, {
            outType: 'UseNoItem',
            outAsAgentId: vm.form.asAgentId,
            inAsAgentId : vm.form.inAsAgentId,
            outDt: vm.form.outDt + 'T00:00:00',
            goodQty : x.txtGoodQty == undefined ? 0 : x.txtGoodQty,
            description : vm.form.description,
            outItemId : 0

          })
          return x;
        });

        let chkValue = "N";
        _.forEach(vm.result, node => {
          if (node.goodQty == 0 || node.goodQty == '' ) {
            chkValue = "Y";
          }
        })
        if (chkValue === "Y") return this.$swal({ type: 'warning', text: '반품수량을 입력해주세요.' })
        else{

          this.$swal({
            type: 'question',
            showCancelButton: true,
            text: '선택한 항목을 저장 하시겠습니까?',
            confirmButtonText: '예',
            cancelButtonText: '아니오',
          }).then(r => {
            if (r.value) {
                  vm.$store.commit('loading')
                  this.$http.post(_url(`/api/workMng/mateDelivery/save`), vm.result)
                      .then((response) => {
                        this.$swal({ type: 'success', text: '반품자재 등록을 완료 했습니다.' })
                            .then((result) => {
                              if (result.value) {
                                this.goSearch();
                              }
                            });
                      })
                      .catch((e) => {
                        this.$swal({ type: 'success', text: '반품자재 등록을 실패 했습니다.' })
                      })
                      .finally(() => {
                        vm.$store.commit('finish')
                      });
            }
          }).catch((e) => {
          })
        }
      } else {
        this.$swal({ type: 'info', text: '저장할 항목을 선택하세요.' });
      }
    },
    onCellValueChanged(params) {
      if (params.colDef.field === "txtGoodQty") {
        const newValue = params.newValue;
        const rowIndex = params.rowIndex;
        const newData = this.rowData[rowIndex];
        if(newData.totalGoodQty < parseInt(newValue)){
          this.$swal({ type: 'info', text: '반품수량이 재고수량보다 많을 수 없습니다.' });
          newData.txtGoodQty = 0
          this.$set(this.rowData, rowIndex, newData);
        }
      }
    },
    chkNumber(params, flag, excRt){
      console.log(params)
      var result = '';
      var val = params.value;
      var data = this.data;

      if(flag === 'sub'){
        data = this.subData;
      }

      if(flag === 'sub') data = this.subData;

      if(!_.isEmpty(val) || _.isNumber(val)){
        val = val.toString();

        if (excRt === 'excRt') result = this.$numeral(val).format('0,0.00');
        else result = this.$numeral(val).format('0,0');
        //data[params.node.id][params.column.colId] = this.$numeral(val).value();
      }

      return result
    },
    getNumberFormat(val) {
      if(val){
        if(typeof val === "string"){
          val = val.replace(/[^0-9]/g, "")
        }

        return Math.floor(val).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
    }
  },
}

</script>

<style lang="scss" scoped>
.modal-card {
  width: 970px;
}

.display-area {
  :global(img) {
    width: 100%;
  }
}

.btn-space {
  margin-right: 4px;
}
</style>